var arabam;
(function (arabam) {
    var BreadcrumbDropdown = /** @class */ (function () {
        function BreadcrumbDropdown($timeout, CommonHelperService, HttpHelperService) {
            var _this = this;
            this.$timeout = $timeout;
            this.CommonHelperService = CommonHelperService;
            this.HttpHelperService = HttpHelperService;
            this.restrict = "A";
            this.scope = {
                catId: "@",
                catParentId: "@"
            };
            this.link = function ($scope, element) {
                var isListItemsLoaded = false;
                var wrapperDomEl = document.getElementById("js-hook-for-hover-breadcrumb-dropdown-" + $scope.catId);
                var domEl = element[0];
                var endpoint = +$scope.catParentId === +$scope.catId
                    ? "/search/child-categories?Id=0"
                    : "/search/child-categories?categoryId=" + +$scope.catParentId;
                var openFn = function () {
                    wrapperDomEl.classList.remove("dn");
                    if (!isListItemsLoaded) {
                        getListObjects();
                    }
                };
                var closeFn = function () {
                    wrapperDomEl.classList.add("dn");
                };
                var createListDomTree = function (listObject) {
                    // dom manipulation
                    var frag = document.createDocumentFragment();
                    var domLi = document.createElement("li");
                    var domA = document.createElement("a");
                    var text = document.createTextNode(listObject.Name);
                    domA.appendChild(text);
                    domA.classList.add("dropdown-menu-on-hover");
                    domA.href = "/ikinci-el/" + listObject.AbsoluteUrl;
                    domA.onclick = function () {
                        _this.CommonHelperService.setDataLayer("Ilan Detay", "Breadcrumb alt kategori", "Click", "gaEvent", true);
                        window.location.href = domA.href;
                    };
                    domLi.appendChild(domA);
                    domLi.classList.add("one-line-overflow");
                    frag.appendChild(domLi);
                    return frag;
                };
                var bindFailedState = function () {
                    console.warn("breadcrumb datasi cekilemedi.");
                };
                var getListObjects = function () {
                    _this.HttpHelperService.httpGetWithPromise(endpoint, {
                        isNotLoading: true
                    })
                        .then(function (response) {
                        if (response.Success && response.Data.length > 0) {
                            response.Data.map(function (childCategoryItem) {
                                var Name = childCategoryItem.Name, AbsoluteUrl = childCategoryItem.AbsoluteUrl;
                                var liDomElem = createListDomTree({
                                    Name: Name,
                                    AbsoluteUrl: AbsoluteUrl
                                });
                                wrapperDomEl.appendChild(liDomElem);
                            });
                            isListItemsLoaded = true;
                        }
                        else {
                            bindFailedState();
                        }
                    })
                        .catch(bindFailedState);
                };
                hoverintent(domEl, openFn, closeFn).options({
                    timeout: 199,
                    interval: 199
                });
            };
        }
        BreadcrumbDropdown.factory = function () {
            var directive = function ($timeout, CommonHelperService, HttpHelperService) {
                return new BreadcrumbDropdown($timeout, CommonHelperService, HttpHelperService);
            };
            directive.$inject = [
                "$timeout",
                "CommonHelperService",
                "HttpHelperService"
            ];
            return directive;
        };
        return BreadcrumbDropdown;
    }());
    var appName = document.body.parentNode.getAttribute("ng-app");
    angular
        .module(appName)
        .directive("breadcrumbDropdown", BreadcrumbDropdown.factory());
})(arabam || (arabam = {}));
